module.exports = __webpack_public_path__ + "img/stock3.cb0b3503.png";